"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePremiumCalculationDto = exports.UpdatePremiumCalculationDocumentDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const create_premium_calculation_dto_1 = require("./create-premium-calculation.dto");
class UpdatePremiumCalculationDocumentDto {
}
exports.UpdatePremiumCalculationDocumentDto = UpdatePremiumCalculationDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePremiumCalculationDocumentDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
    }),
    (0, class_validator_1.IsInt)({ message: "Document Type ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document Type ID is required." }),
    tslib_1.__metadata("design:type", Number)
], UpdatePremiumCalculationDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 35,
    }),
    (0, class_validator_1.IsInt)({ message: "Document ID must be a number." }),
    (0, class_validator_1.IsNotEmpty)({ message: "Document ID is required." }),
    tslib_1.__metadata("design:type", Number)
], UpdatePremiumCalculationDocumentDto.prototype, "documentId", void 0);
class UpdatePremiumCalculationDto {
}
exports.UpdatePremiumCalculationDto = UpdatePremiumCalculationDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], UpdatePremiumCalculationDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Status Lookup ID",
        example: 403,
    }),
    (0, class_validator_1.IsInt)({ message: "Status Lookup ID must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "Status Lookup ID is required" }),
    tslib_1.__metadata("design:type", Number)
], UpdatePremiumCalculationDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Premium calculation details as key-value pairs",
        example: {
            "101": "This is my Commercial vessels data",
            "102": "This is my ships",
            "103": "This is my data",
        },
    }),
    (0, class_validator_1.IsObject)({ message: "premiumCalculationDetails must be an object" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], UpdatePremiumCalculationDto.prototype, "premiumCalculationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Remarks section object",
        type: create_premium_calculation_dto_1.RemarksSectionDto,
    }),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => create_premium_calculation_dto_1.RemarksSectionDto),
    tslib_1.__metadata("design:type", typeof (_b = typeof create_premium_calculation_dto_1.RemarksSectionDto !== "undefined" && create_premium_calculation_dto_1.RemarksSectionDto) === "function" ? _b : Object)
], UpdatePremiumCalculationDto.prototype, "remarksSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Array of document objects",
        type: [UpdatePremiumCalculationDocumentDto],
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ message: "Documents must be an array" }),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => UpdatePremiumCalculationDocumentDto),
    tslib_1.__metadata("design:type", Array)
], UpdatePremiumCalculationDto.prototype, "documents", void 0);
